import "./App.css";
import "react-datepicker/dist/react-datepicker.css";
import { useEffect, useRef } from "react";
import { ResizableContent } from "./components/app/ResizableContent";
import {
  availableHippodromes,
  availableRuns,
  changeShownRun,
  handleOptionChanges,
  results,
  shownRun,
  shownRunSubject,
  statisticsOptions,
  statisticsOptionsSubject,
} from "./stores/statistics.store";
import StatisticsOptionsWidget from "./components/shared/statistics_options/StatisticsOptions";
import AppRouters from "./routers";
import { formatDateForBulletin, getDailyBulletin, useForceUpdate } from "./services/misc.functions";
import ModalService, { modalServiceSubject } from "./components/shared/modal/Modal";

const { innerWidth: width } = window;
export let isMobile = width < 767.98;

const resizeWindow = () => {
  const { innerWidth: width } = window;
  const nowIsMobileView = width < 767.98;
  if (isMobile !== nowIsMobileView) {
    window.location.reload();
  }
};

function App() {
  const forceUpdate = useForceUpdate();
  const prevDateRef: any = useRef();

  useEffect(() => {
    window.addEventListener("resize", resizeWindow);
    return () => {
      window.removeEventListener("resize", resizeWindow);
    };
  }, []);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data.type === "SEND_HIPPO_KEY") {
        const hippodrome_key = event.data.hippodrome_key;

        if (hippodrome_key !== "istatistikler") {
          handleOptionChanges(statisticsOptions.date, hippodrome_key.toUpperCase());
        } else {
          handleOptionChanges(statisticsOptions.date, availableHippodromes[0].tjk_key);
        }
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  useEffect(() => {
    let statisticsOptionsSub = statisticsOptionsSubject.subscribe((changes) => {
      if (prevDateRef.current !== formatDateForBulletin(changes.date)) {
        getDailyBulletin(formatDateForBulletin(changes.date));
        prevDateRef.current = formatDateForBulletin(changes.date);
      }

      if (availableRuns && statisticsOptions.selectedHippodrome) {
        var queryParams = new URLSearchParams(window.location.search);
        queryParams.set("hipodrom", statisticsOptions.selectedHippodrome.tjk_key.toLowerCase());
        // eslint-disable-next-line no-restricted-globals
        history.replaceState(null, "", window.location.pathname + "?" + queryParams.toString());

        changeShownRun(
          availableRuns.find((item: any) => item.hippodrome_key === statisticsOptions.selectedHippodrome.tjk_key)
        );
      }

      forceUpdate();
    });

    let shownRunSub = shownRunSubject.subscribe(() => {
      forceUpdate();
    });

    return () => {
      statisticsOptionsSub.unsubscribe();
      shownRunSub.unsubscribe();
    };
  }, [forceUpdate]);

  return (
    <ResizableContent>
      <div style={{ backgroundColor: "#fff", borderRadius: "1rem" }}>
        <svg style={{ display: "none" }}>
          <defs>
            <path id="tabshape" d="M80,60C34,53.5,64.417,0,0,0v60H80z"></path>
          </defs>
        </svg>
        <div className="betting-run-tabs" id="program-tabs">
          <ul className="nav nav-tabs">
            <li className={`nav-item active`}>
              <svg className="left" viewBox="0 0 80 60" preserveAspectRatio="none">
                <use xlinkHref="#tabshape"></use>
              </svg>
              <a className="nav-link d-flex align-items-center nowrap-ellipsis">İSTATİSTİKLER</a>
              <svg viewBox="0 0 80 60" preserveAspectRatio="none">
                <use xlinkHref="#tabshape"></use>
              </svg>
            </li>
          </ul>
        </div>

        <StatisticsOptionsWidget />
      </div>

      <div className="statistics-widget">
        <div className="page-widget">
          <svg style={{ display: "none" }}>
            <defs>
              <path id="tabshape" d="M80,60C34,53.5,64.417,0,0,0v60H80z"></path>
            </defs>
          </svg>
          <div className="betting-run-tabs" id="program-tabs">
            <ul className="nav nav-tabs">
              {availableRuns &&
                availableRuns.length > 0 &&
                statisticsOptions &&
                statisticsOptions.selectedHippodrome &&
                availableRuns
                  .filter((item: any) => item.hippodrome_key === statisticsOptions.selectedHippodrome.tjk_key)
                  .map((run: any, keyRun: number) => {
                    return (
                      <li
                        key={`runItem-${keyRun}`}
                        className={`nav-item ${shownRun.run_no === run.run_no ? "active" : ""}`}
                      >
                        <svg className="left" viewBox="0 0 80 60" preserveAspectRatio="none">
                          <use xlinkHref="#tabshape"></use>
                        </svg>
                        <a
                          className="nav-link d-flex align-items-center nowrap-ellipsis"
                          onClick={() => {
                            changeShownRun(run);
                            if (isMobile) {
                              document.getElementById("program-tabs")?.scroll({
                                top: 1,
                                left:
                                  (100 /
                                    results.filter(
                                      (item: any) => item.hippodrome_key === statisticsOptions.selectedHippodrome
                                    ).length) *
                                  keyRun,
                                behavior: "smooth",
                              });
                            }
                          }}
                        >
                          {shownRun.run_no === run.run_no ? `${run.run_no} . Koşu` : run.run_no}
                        </a>
                        <svg viewBox="0 0 80 60" preserveAspectRatio="none">
                          <use xlinkHref="#tabshape"></use>
                        </svg>
                      </li>
                    );
                  })}
            </ul>
          </div>

          <div className="overflow-hidden">
            {availableHippodromes.length > 0 && statisticsOptions.selectedHippodrome ? (
              <>
                <ModalService />
                <AppRouters />
              </>
            ) : (
              <div className="text-center p-5">Gösterilecek istatistik verisi bulunmuyor.</div>
            )}
          </div>
        </div>
      </div>
    </ResizableContent>
  );
}

export default App;
